<template>
	<div :class="$style.container">
		<div :class="$style.chart">
			<ProjectGaugeChart :chartData="chartData" :options="options" v-if="is_shown_chart"/>
		</div>
		<ul v-if="data && 'sc' in data">
			<li><span>SAFETY CERTAINTY</span> <div>{{data.sc || 'N/A'}}</div></li>
			<li><span>MUSTER EFFICIENCY</span> <div>{{data.me || 'N/A'}}</div></li>
			<li><span>TIME IN WORK ZONE</span><div>{{data.twz || 'N/A'}}</div></li>
			<li><span>FIRST STARTS</span><div>{{data.fs || 'N/A'}}</div></li>
		</ul>
	</div>
</template>



<script>
	import ProjectGaugeChart from '../../../components/charts/ProjectGauge';

	export default {
		components: {
			ProjectGaugeChart
		},
		props: {
			data: Object,
			fillBackground: {
				String,
				default: '#CDCDCD'
			},
			centerLabelColor: {
				String,
				default: '#757575'
			},
			emptyBackground: {
				String,
				default: '#CDCDCD'
			}
		},
		data: function() {
			return {
				is_shown_chart: false,
				chartData: {
					datasets: [{
						data: [0, 100],
						backgroundColor: [this.fillBackground, this.emptyBackground],
						hoverBackgroundColor: [this.fillBackground, this.emptyBackground],
						centerLabelColor: this.centerLabelColor,
						borderWidth: 0
					}]
				},
				options: {
					cutoutPercentage: 82,
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					}
				}
			}
		},
		watch: {
			data: {
				handler() {
					this.fillData();
				},
				immediate: true
			}
		},
		methods: {
			fillData () {
				var {value} = this.data;
				const maxValue = 100;

				if (value == undefined) value = 0;

				const {
					fillBackground,
					centerLabelColor,
					emptyBackground
				} = this;

				this.chartData = {
					datasets: [{
						data: [value, maxValue - value],
						backgroundColor: [fillBackground, emptyBackground],
						hoverBackgroundColor: [fillBackground, emptyBackground],
						centerLabelColor: centerLabelColor,
						borderWidth: 0
					}]
				}
				this.is_shown_chart = true;
			}
		}
	}
</script>

<style lang="scss" module rel="stylesheet/scss">

	.container {
		width: 100%;
		height: 250px;
		margin: 0 auto;
		position: relative;

		display: flex;
		justify-content: center;
		align-items: center;

		ul {


			li {
				border-bottom: 1px solid #AEB0B3;
				box-sizing: border-box;
				color: #AEB0B3;
				display: flex;
				align-items: center;
				padding: 0px 10px;
				&:last-child {
					border: none;
				}

				span {
					padding-right: 30px;
				}

				div {
					flex-grow: 1;
					text-align: right;
					font-weight: bold;
					color: #86888C;
				}

			}
		}
	}
	.chart {
		position: relative;
		z-index: 2;
		width: 250px;
	}
</style >
